import { Profile } from 'oidc-client';
import type { Key } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteHelper';
import { MatchVm } from '../../../utils/api';
import MatchTable from './MatchTable';

interface OwnProps {
    userProfile: Profile;
    wrappedComponentRef?: any;
    matchesFromProps?: MatchVm[];
    onMatchOfficialsDrawerOpen: (matchId: number) => void;
    onMatchDetailsDrawerOpen: (matchId: number) => void;
    /** Step 1 of batch add officials: row checkboxes */
    batchSelectionMode?: boolean;
    batchSelectedRowKeys?: Key[];
    onBatchSelectedRowKeysChange?: (keys: Key[]) => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(MatchTable);
